import { Checkbox } from '@unifyapps/ui/components/Checkbox';
import { Stack } from '@unifyapps/ui/components/Stack';
import { Typography } from '@unifyapps/ui/components/Typography';
import type { SyntheticEvent } from 'react';
import type { NotificationEventType } from '../../types';
import { NotificationEvents } from '../../utils/notificationEvents';

type Props = {
  name: string;
  events: NotificationEventType[];
  onToggleGroup: (groupName: string, channelType: string) => void;
  channelTypes: { id: string; name: string }[];
  preferences: Record<string, Record<string, boolean>> | undefined;
  groupId: string;
};

const stopPropagation = (event: SyntheticEvent) => {
  event.stopPropagation();
};

const CHECK_BOX_SLOT_PROPS = {
  label: {
    className: 'text-xs !font-regular text-tertiary',
  },
};

export function GroupHeader({
  name,
  onToggleGroup,
  events,
  channelTypes,
  preferences,
  groupId,
}: Props) {
  return (
    <Stack className="w-full items-center justify-between" direction="row">
      <Typography color="text-primary" variant="text-sm" weight="medium">
        {name}
      </Typography>
      {channelTypes.map((channelType) => (
        <Checkbox
          checked={NotificationEvents.isGroupSelected({ events, preferences, channelType })}
          className="flex w-[108px] items-center"
          key={channelType.id}
          label={channelType.name}
          onChange={() => {
            onToggleGroup(groupId, channelType.id);
          }}
          onClick={stopPropagation}
          slotProps={CHECK_BOX_SLOT_PROPS}
        />
      ))}
    </Stack>
  );
}
